import React, { Component } from 'react';
import { inject, observer } from "mobx-react";

@inject('store')
@observer
class Auth extends Component {

    render() {
        const { ES: data = [] } = this.props.store.auth;
        if (data.includes(this.props.auth)) {
            return (
                <span
                    style={{ cursor: "pointer", color: "#1890ff" }}
                    onClick={() => {
                        if (this.props.path.includes('#')) {
                            document.getElementById(this.props.path.replace('#', "")).scrollIntoView();
                            return
                        }
                        this.props.history.push(this.props.path)
                    }}
                > {this.props.children}</span >
            )
        } else {
            return this.props.children
        }
    }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/components/table/IsLableAuth.js